<div class="actions-wrapper">
  <qm-element-actions
    *ngIf="currentFeature"
    [selectedFeature]="currentFeature"
    [selectedLayer]="currentFeature.layer"
    [visibleButtons]="{info: false, flag: true, focus: true, follow: false}">
  </qm-element-actions>
</div>
<qm-element-timeline [currentFeature]="currentFeature"></qm-element-timeline>

<!-- qm-measurements-feature is internally disabled, so for now there's no need to have the tabs at all -->
<!--
<ngb-tabset>
  <ngb-tab>
    <ng-template ngbTabTitle>
      {{'Timeline' | translate}}
    </ng-template>
    <ng-template ngbTabContent>
      <qm-element-timeline [currentFeature]="currentFeature"></qm-element-timeline>
    </ng-template>
  </ngb-tab>
  <ngb-tab>
    <ng-template ngbTabTitle>
      {{'Measurements' | translate}}
    </ng-template>
    <ng-template ngbTabContent>
      <qm-measurements-feature [currentFeature]="currentFeature"></qm-measurements-feature>
    </ng-template>
  </ngb-tab>
</ngb-tabset>
-->
